import getSvgData from '../components/svg/get-svg-data';

export function formatHours(time) {
  // NOTE: Is there a better approach here?
  if (!time) {
    return '';
  }
  // Check correct time format and split into components
  let tempTime = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

  if (tempTime.length > 1) { // If time format correct
    tempTime = tempTime.slice(1); // Remove full string match value
    tempTime = tempTime.slice(0, 3); // Remove seconds from time
    tempTime[5] = +tempTime[0] < 12 ? 'am' : 'pm'; // Set am/pm
    tempTime[0] = +tempTime[0] % 12 || 12; // Adjust hours
  }
  return tempTime.join(''); // return adjusted time or original string
}

export function formatDayOfWeek(dayString) {
  // NOTE: Is there a better approach here?
  if (typeof dayString === 'string') {
    return dayString.charAt(0) + dayString.substring(1).toLowerCase();
  }
  return '';
}

export function getDropOffLocationImage(location) {
  const providerType = location?.providerType;

  switch (providerType) {
    case 'FEDEX_ONSITE':
    case 'FEDEX_OFFICE':
    case 'FEDEX_SELF_SERVICE_LOCATION':
    case 'FEDEX_AUTHORIZED_SHIP_CENTER':
    case 'FEDEX_EXPRESS_STATION':
    case 'FEDEX_SHIPSITE':
    case 'FEDEX_FREIGHT_SERVICE_CENTER':
    case 'FEDEX_HOME_DELIVERY_STATION':
    case 'FEDEX_SMART_POST_HUB':
    case 'FEDEX_SHIP':
    case 'FEDEX_SHIP_AND_GET':
      return getSvgData('fedex');
    case 'ACF':
      return getSvgData('anf');
    case 'KID':
      return getSvgData('kids');
    case 'HOL':
      return getSvgData('hco');
    case 'GH':
      return getSvgData('hco');
    default:
      return '';
  }
}

export function getDropOffLocationName(location) {
   const providerType = location?.providerType;

  switch (providerType) {
    case 'FEDEX_ONSITE':
    case 'FEDEX_OFFICE':
    case 'FEDEX_SELF_SERVICE_LOCATION':
    case 'FEDEX_AUTHORIZED_SHIP_CENTER':
    case 'FEDEX_EXPRESS_STATION':
    case 'FEDEX_SHIPSITE':
    case 'FEDEX_FREIGHT_SERVICE_CENTER':
    case 'FEDEX_HOME_DELIVERY_STATION':
    case 'FEDEX_SMART_POST_HUB':
    case 'FEDEX_SHIP':
    case 'FEDEX_SHIP_AND_GET':
      return 'fedex';
    case 'ACF':
      return 'anf';
    case 'KID':
      return 'kids';
    case 'HOL':
    case 'GH':
      return 'hco';
    default:
      return '';
  }
}

export function mapMarkerPropsBuilder(location) {
  if (!location) { return null; }
  return {
    key: location.id,
    label: `${location.id}-map-marker`,
    latitude: location.geoPosition.latitude,
    longitude: location.geoPosition.longitude,
  };
}
